import React, { useState, useRef, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'

const col1 = [
  { id: 'southern-grounded-hornbill', status: 'VULNERABLE',   name: 'Southern Grounded Hornbill', count: '1,500 lives counting' },
  { id: 'saddle-billed-stork', status: 'LEAST CONCERN', name: 'Saddle Billed Stork',       count: '10,000 - 20,000 lives counting' },
  { id: 'cape-gannet', status: 'ENDANGERED',   name: 'Cape Gannet',                count: '150,000 - 250,000 counting' },
]
const col2 = [
  { id: 'pels-fishing-owl', status: 'ENDANGERED',        name: "Pel's Fishing Owl", count: '70 - 100 individual lives counting' },
  { id: 'bearded-vulture', status: 'NEARLY THREATENED', name: 'Bearded Vulture',   count: '2000 - 10,000 lives counting' },
]
const col3 = [
  { id: 'african-penguin', status: 'CRITICALLY ENDANGERED', name: 'African Penguin', count: '10,000 lives counting' },
]

const SpeciesItem = ({ id, status, name, count }) => (
  <Link to={`/${id}`} className="species-item" style={{ textDecoration: 'none' }}>
    <div className="species-item__inner">
      <div className="species-item__left">
        {/* <span className="species-status">{status}</span> */}
        <span className="species-name">{name}</span>
        <span className="species-count">{count}</span>
      </div>
      <div className="species-item__arrow">
        <ArrowRight size={14} strokeWidth={1.5} />
      </div>
    </div>
  </Link>
)

const Navbar = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const dropdownRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  return (
    <nav className="hornbill-navbar">
      <div className="hornbill-container">

        <div className="hornbill-logo">
          <Link to="/">
            <img src="/Images/logo.png" alt="Save Hornbills" />
          </Link>
        </div>

        <ul className="hornbill-menu">
          <li className="nav-dropdown-wrapper" ref={dropdownRef}>
            <a
              href="/"
              className={dropdownOpen ? 'active' : ''}
              onClick={(e) => { e.preventDefault(); setDropdownOpen(!dropdownOpen) }}
            >
              Endangered Species
              <svg
                width="10" height="10" viewBox="0 0 10 10" fill="none"
                style={{
                  transition: 'transform 0.2s',
                  transform: dropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)'
                }}
              >
                <path d="M2 3.5L5 6.5L8 3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>

            <div className={`species-dropdown ${dropdownOpen ? 'species-dropdown--open' : ''}`}>
              <div className="species-dropdown__grid">
                <div className="species-col">
                  {col1.map((s, i) => <SpeciesItem key={i} {...s} />)}
                </div>
                <div className="species-col">
                  {col2.map((s, i) => <SpeciesItem key={i} {...s} />)}
                </div>
                <div className="species-col">
                  {col3.map((s, i) => <SpeciesItem key={i} {...s} />)}
                </div>
              </div>
            </div>
          </li>

          <li><Link to="/about">About</Link></li>
          <li><Link to="/solution">Solution</Link></li>
          <li><Link to="/contact">Contact</Link></li>
        </ul>

        <div className="hornbill-actions">
          {/* <button className="search-icon" aria-label="Search">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="11" cy="11" r="8"/>
              <path d="M21 21l-4.35-4.35"/>
            </svg>
          </button> */}
          <Link to="/donate">
            <button className="donate-button">DONATE</button>
          </Link>
          <button className="hamburger" aria-label="Menu">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="3" y1="6" x2="21" y2="6"/>
              <line x1="3" y1="12" x2="21" y2="12"/>
              <line x1="3" y1="18" x2="21" y2="18"/>
            </svg>
          </button>
        </div>

      </div>
    </nav>
  )
}

export default Navbar